import "./src/styles/fonts.css"

export const onInitialClientRender = () => {
  let body = document.getElementsByTagName("body")[0]
  body.classList.add("page-has-loaded")
}
